import { IconButton, Grid, Button } from "@material-ui/core"
import { useDispatch } from "react-redux"
import LocalAtmIcon from '@material-ui/icons/LocalAtm'
import { AutorizarAgenteCompraItem, obtenerComprasItemPaquete } from "./../../../../ducks/viajeCalendarioDuck"
import { useState } from "react"
import { ToastMessage } from "../../../../global/ToastMessage"
import BackDrop from "../../../../global/BackDrop"
import { DialogMessage } from "../../../../global/DialogMessage"
import { ButtonAutorizacionStyle } from "./ButtonAutorizacionStyle"
import { formatDinero } from "./../../../../utils/formatDinero"
import HeaderModal from "../../../../global/headerModal";
import ModalBase from "./../../../../global/ModalBase";
const ModalMensaje = (props) => {
    const {Compra, open = false, setOpen=()=>{}, idPaquete = 0} = props
    const dispatch = useDispatch()
    const classes = ButtonAutorizacionStyle()
    const [load, setLoad] = useState(false)
    const handleClose = () => {
        setOpen(false)
    }
    const onGuardar = () => {
        DialogMessage.fire({
            title: `¿Esta seguro de mandar al area de finanazas
            la solicitud de pago de este Item?`,
            text: '',
            showCancelButton: true,
            confirmButtonText: "Aplicar",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoad(true)
                dispatch(AutorizarAgenteCompraItem({ idCompra: Compra.idCompra })).then(Response => {
                    if (Response.status || Response?.status === 500) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                        });
                        setLoad(false)
                        return null
                    }
                    ToastMessage.fire({
                        icon: "success",
                        title: "Operación exitoasa",
                    });
                    dispatch(obtenerComprasItemPaquete({ IdPaquete: idPaquete }))
                    setLoad(false)
                })
            }
        })
    }
    return (
        <ModalBase classes={classes} open={open} onClose={handleClose}>
        <HeaderModal
            handleClose={handleClose}
            titulo="Solicitar Pago de Item"
        />
        <Grid container className={classes.containerSpacing}>
            <Grid item xs={12}>
                <div style={{ margin: '10px' }}>
                    <p>Motivo: <b>{Compra.TipoCompra?.Descripcion}</b></p>
                    <p>Monto pagado: <b>{formatDinero(Compra.MontoProveedor)} {Compra.moneda?.Clave}</b></p>
                </div>
            </Grid>
        </Grid>
        <Grid container className={classes.containerSpacing}>
            <Grid item xs={12} className={classes.modalBotonesCenter}>
                <Button
                    variant="contained"
                    color="primary"
                    className={classes.modalBoton}
                    onClick={onGuardar}
                >
                    Aplicar
                </Button>
            </Grid>
        </Grid>
        <BackDrop open={load} />
    </ModalBase>
    )
}

const ButtonAutorizarCompra = (props) => {
    const { Compra, idPaquete } = props
    const [open, setOpen] = useState(false)
    const onOpen = () => {
        setOpen(true)
    }
    return (
        <div>
            <IconButton aria-label="Pagar" onClick={onOpen} >
                 <LocalAtmIcon color='primary' />
            </IconButton>
            <ModalMensaje open={open} setOpen={setOpen} Compra={Compra} idPaquete={idPaquete} />
        </div>

    )
}
export default ButtonAutorizarCompra